<template>
  <div>

    <div id="activity-graph" class="insetGraph">
      <mu-card class="line-graph" style="padding: 0">
        <mu-paper style="text-align: center;">
          <mu-content-block>
            <service-tracking-types
              style="float:right;display: inline-block;margin-top: 4px;margin-bottom: 12px"
              type="activity"
              @onTrackingType_activity="onTrackingTypeActivity"
              current-service="FITBIT"
            ></service-tracking-types>
          </mu-content-block>
          <div style="clear:both"></div>
        </mu-paper>
      </mu-card>
    </div>


    <mu-row gutter v-if="$store.state.user.scope" class="content">
      <mu-col desktop="30" tablet="50">

        <activity-input class="card-spacing" style="margin-top: 24px"
                        :bmr="$store.state.user.stats.bmr"></activity-input>
        <tracking-notifier
          :userId="$store.state.user.scope.user_id"
        ></tracking-notifier>
      </mu-col>
      <mu-col desktop="70" tablet="50">
        <mu-card
          style="margin-top: 24px; padding-top: 8px"
          id="blood-glucose-data"
          class="tracking-data"
        >
          <mu-timeline>
            <div v-for="group, groupKey in groupFilter()" :key="'group-key-' + groupKey" style="margin-bottom: 16px;">
              <div v-for="titleItem, titleIndex in group" :key="'title-index-' + titleIndex" v-if="titleIndex === 0"
                   class="timelineSpacing">
                <div class="bold timelineTitle groupedDate"
                     v-text="groupedDateFormat(titleItem.startTime)">
                </div>
              </div>
              <div v-for="item, index in group" class="timelineSpacing" :key="'tracking-timeline-item-' + index">
                <mu-timeline-item
                  :iconColor="btnColor"
                  iconLine="8"
                  iconType="solid"
                >
                  <div>
                    <mu-row>
                      <mu-col>
                        <div class="trackingDate"
                             v-text="groupedItemDate(item.startTime, item.duration)"></div>

                      </mu-col>
                      <mu-col class="reading">
                        {{item.activityName}}
                      </mu-col>
                    </mu-row>
                    <div class="reading" style="margin-bottom: 12px;">{{duration(item.duration)}}</div>


                    <div style="display: inline-block;margin-right: 8px;">
                      <mu-icon style="position:relative; top: 2px;" size="16" color="#3d8517" value="directions_walk"></mu-icon>
                      {{numberFormat(item.calories)}} <span class="lite">kcal</span></div>


                    <div style="display: inline-block">
                      <mu-icon style="position:relative; top: 2px;" size="16" color="red" value="favorite"></mu-icon>
                      {{item.averageHeartRate}} <span class="lite">avg bpm</span></div>


                    <div style="margin-top: 8px;" v-if="item.heartRateZones && item.calories > 0">
                     <mu-icon style="position:relative; top: 2px;" size="16" value="access_time"></mu-icon> {{fatBurnPercentageMins(item.heartRateZones)}} of fat burn
                      <div class="heartRateZone" style="width: 250px">
                        <div :style="{width: fatBurnPercentage(item.heartRateZones)}" class="fillBar">

                        </div>
                      </div>

                    </div>


                  </div>
                </mu-timeline-item>
              </div>
            </div>
          </mu-timeline>
          <mu-card-text align=" center" v-if="isReadingsLoading === true">
            <mu-circular-progress color="#0179d5"></mu-circular-progress>
            <div>{{$t('message.loadingText')}}</div>
          </mu-card-text>
          <div v-if="isReadingsLoading === false" ref="detector"></div>
        </mu-card>
      </mu-col>
    </mu-row>
  </div>
</template>
<script>

  import ScrollManager from '../../helpers/ScrollManager'
  import SleepGraph from "../../components/Tracking/Graphs/Sleep/LineGraph";

  let fromDate = moment().subtract(1, 'month');
  let toDate = moment();

  import SleepApi from '../../api/Tracking/Sleep'
  import SleepInput from "../../components/Tracking/Input/Sleep/Sleep";
  import SleepEdit from "../../components/Tracking/Edit/Sleep/SleepEdit";

  import ActivityApi from '../../api/Tracking/Activity'
  import IntegrationApi from '../../api/Integrations'

  import TrackingNotifier from "../../components/TrackingNotifier/TrackingNotifier.vue";
  import TrackingExporter from "../../components/Tracking/Exporter/Exporter.vue";
  import ActivityInput from "../../components/Tracking/Input/Activity/Activity";
  import ActivityLineGraph from "../../components/Tracking/Graphs/Activity/LineGraph";

  import activityTypes from '../../components/Tracking/activityTypes'
  import ServiceTrackingTypes from "../../components/Tracking/ServiceTrackingTypes/ServiceTrackingTypes";
  import config from '../../config'
  import numeral from 'numeral'

  export default {
    components: {
      ServiceTrackingTypes,
      ActivityLineGraph,
      ActivityInput,
      TrackingExporter,
      TrackingNotifier,
      SleepEdit,
      SleepInput,
      SleepGraph
    },
    data() {
      return {
        btnColor: '#4f2bb4',
        data: [],
        isReadingsLoading: true
      }
    },
    mounted() {
      let self = this;
      self.$gtag.pageview('/tracking/activity/fitbit');
      self.loadData();
      self.$nextTick(function () {
        let element = document.getElementsByClassName('main-content')[0];
        element.addEventListener('scroll', self.handleScroll);
      })
    },
    methods: {
      numberFormat(num) {
        let number = numeral(num);
        return number.format();
      },
      fatBurnPercentageMins(zones) {
        let fatBurnMinutes = zones[1].minutes;
        return moment.duration(fatBurnMinutes, 'minutes').humanize(false);
      },
      fatBurnPercentage(zones) {
        let outOfRangeMinutes = zones[0].minutes;
        let fatBurnMinutes = zones[1].minutes;
        let cardioMinutes = zones[2].minutes;
        let peakMinutes = zones[3].minutes;
        let total = (outOfRangeMinutes + fatBurnMinutes + cardioMinutes + peakMinutes);
        return ((fatBurnMinutes / total) * 100).toFixed(1) + '%';

      },
      duration(ms) {
        let self = this;
        let hours = moment.duration(ms, 'milliseconds').get('hours');
        let minutes = moment.duration(ms, 'milliseconds').get('minutes');
        if (hours === 0) {
          return (minutes) + ' min'
        }
        if (hours > 0) {
          return hours + 'h ' + (minutes) + ' min'
        }
      },
      handleScroll: function () {
        let self = this;
        if (!self.isReadingsLoading) {
          if (ScrollManager.isElementInViewport(self.$refs['detector'])) {
            self.loadMoreData();
          }
        }
      },
      loadMoreData() {
        let self = this;
        //IntegrationApi.a
      },
      groupedDateFormat(date) {
        let self = this;
        return moment(date).calendar(null, {
          lastDay: '[This week]',
          sameDay: '[This week]',
          nextDay: '[Tomorrow]',
          lastWeek: '[last] dddd',
          nextWeek: 'dddd',
          sameElse: moment(date).startOf('isoWeek').format('DD/MM/YYYY') + ' - ' + moment(date).endOf('isoWeek').format('DD/MM/YYYY')
        })
      },
      groupedItemDate(date, duration) {
        let self = this;
        let offset = new Date();
        let dateMod = moment.utc(date).local().locale(config.language);
        return dateMod.format('hh:mm a') + ' on ' + dateMod.format('dddd Do');
      },
      onTrackingTypeActivity(value) {
        let self = this;
        if (value === 'LCP') {
          self.$router.push({
            name: 'ActivityProgress'
          })
        }
      },
      loadData() {
        let self = this;
        let today = moment().utc().local();
        self.isReadingsLoading = true;
        IntegrationApi.FITBIT.getActivityLog(today.format('YYYY-MM-DD'))
          .then(function (response) {
            self.isReadingsLoading = false;
            self.data = response.data.activities;

            self.$forceUpdate();
          })
          .catch(function (error) {
            self.isReadingsLoading = false;
          });
      },
      groupFilter() {
        let self = this;
        return _.groupBy(self.data, function (reading) {
          return moment(reading.startTime).startOf('isoWeek').format();
        })
      }
    },
    beforeDestroy() {
      this.$EventBus.$off('activityReadingAdded');
      this.$EventBus.$off('activityReadingReceived')
    }
  }
</script>
<style>
  .lite {
    color: #7b7b7b;
  }
</style>
<style scoped lang="less">

  .heartRateZone {
    margin-top: 16px;
    background: #ebebeb;
    .fillBar {
      padding: 4px;
      background: orange;
    }
  }

  @bgBranding: #4e2288;

  .timelineSpacing.notEditMode:hover {
    background: fade(@bgBranding, 10%);
    cursor: pointer;
  }

  .whiteTitle {
    font-size: 18px !important;
    color: white !important;

  }
</style>



// WEBPACK FOOTER //
// ActivityFitbit.vue?ccab35a6